import React, { useState } from "react";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    subject: "",
    message: "",
  });

  const [formMessage, setFormMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Send formData to backend
      const response = await fetch("mail.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.text();
      setFormMessage("Message sent successfully!");
      console.log(result);
    } catch (error) {
      setFormMessage("There was an error sending the message.");
      console.error(error);
    }
  };

  return (
    <div className="space overflow-hidden" id="contact-sec">
      <div className="container">
        <div className="row gy-5 flex-row-reverse">
          <div className="col-lg-6">
            <div className="contact-image6">
              <img
                src="/assets/image/IMG-20250429-WA0009.jpg"
                alt="Contact"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div>
              <div className="title-area mb-30">
                <span className="sub-title6">
                  Get in touch
                  <span className="shape right">
                    <span className="dots"></span>
                  </span>
                </span>
                <h2 className="sec-title">
                  Contact Us Today for a Free Quote!
                </h2>
              </div>
              <form className="contact-form6" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      <i className="fal fa-user"></i>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="tel"
                        name="number"
                        className="form-control"
                        placeholder="Phone Number"
                        value={formData.number}
                        onChange={handleChange}
                      />
                      <i className="fal fa-phone"></i>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="subject"
                        className="form-control"
                        placeholder="Subject"
                        value={formData.subject}
                        onChange={handleChange}
                      />
                      <i className="fal fa-edit"></i>{" "}
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        className="form-control"
                        placeholder="Write Your Message"
                        rows="3"
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>
                      <i className="fal fa-pencil"></i>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-btn">
                      <button type="submit" className="th-btn">
                        Send Message{" "}
                        <i className="fa-regular fa-arrow-right ms-2"></i>
                      </button>
                    </div>
                  </div>
                </div>
                {formMessage && (
                  <p className="form-messages mb-0 mt-3">{formMessage}</p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
